class MeetingInterfaces {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/:activityId/meetings`;
    this.baseActivityPath = `${basePath}/:activityId`;
    this.apiClient = apiClient;

  }

  async rescheduleMeeting(activityId, meetingId, data) {

    const path = `${this.basePath}/:meetingId/reschedule`;

    return this.apiClient.put(path, { activityId, meetingId }, {}, data);

  }

  async cancelMeeting(activityId, meetingId) {

    const path = `${this.basePath}/:meetingId`;

    return this.apiClient.delete(path, { activityId, meetingId }, {});

  }

  async attendMeeting(activityId) {

    const path = `${this.baseActivityPath}/attend`;

    return this.apiClient.put(path, { activityId }, {}, {});

  }

  async mayAttendMeeting(activityId) {

    const path = `${this.baseActivityPath}/may-be`;

    return this.apiClient.put(path, { activityId }, {}, {});

  }

  async declineMeeting(activityId) {

    const path = `${this.baseActivityPath}/decline`;

    return this.apiClient.put(path, { activityId }, {}, {});

  }

  async attendAllUpcomingMeetings(activityId) {

    const path = `${this.baseActivityPath}/attend-all`;

    return this.apiClient.put(path, { activityId }, {}, {});

  }

  async mayAttendAllUpcomingMeetings(activityId) {

    const path = `${this.baseActivityPath}/may-be-all`;

    return this.apiClient.put(path, { activityId }, {}, {});

  }

  async declineAllUpcomingMeetings(activityId) {

    const path = `${this.baseActivityPath}/decline-all`;

    return this.apiClient.put(path, { activityId }, {}, {});

  }

  async uninviteAttendee(activityId) {

    const path = `${this.baseActivityPath}/uninvite`;

    return this.apiClient.put(path, { activityId }, {}, {});

  }

  async uninviteAttendeeFromUpcomingMeetings(activityId) {

    const path = `${this.baseActivityPath}/uninvite-upcoming`;

    return this.apiClient.put(path, { activityId }, {}, {});

  }

}

export default MeetingInterfaces;